/* import __COLOCATED_TEMPLATE__ from './link-to-dashboard-web.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
/**
 * A component that creates a link to a page within the dashboard web app.
 * This will automatically route to the correct destination: either a defined
 * Ember route, or fall back to the <DashboardWebMount /> in the catch_all route.
 *
 * @example
 * ```hbs
 * <LinkToDashboardWeb @path="/ordering-profile/overview">
 *   Go to Ordering Profile
 * </LinkToDashboardWeb>
 * ```
 *
 * @example With additional attributes
 * ```hbs
 * <LinkToDashboardWeb @path="/settings" class="btn btn-primary" data-test="settings-link">
 *   Settings
 * </LinkToDashboardWeb>
 * ```
 */
let LinkToDashboardWeb = (_class = class LinkToDashboardWeb extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
  }
  /**
   * Validates that the path argument is provided and starts with a slash
   */
  get normalizedPath() {
    const {
      path
    } = this.args;
    if (!path) {
      throw new Error('LinkToDashboardWeb requires a @path argument');
    }

    // Ensure path starts with a slash
    return path.startsWith('/') ? path : `/${path}`;
  }

  /**
   * Generates the proper URL by combining rootURL with the normalized path.
   * This ensures the href includes the correct base path (e.g., "/dashboard/").
   */
  get href() {
    return `${this.router.rootURL || '/'}${this.normalizedPath.slice(1)}`;
  }

  /**
   * Handles the click event and navigates using the router.
   * This lets Ember's router decide whether to use a defined route or catch_all.
   */
  handleClick(event) {
    // Allow default behavior for modified clicks (cmd+click, ctrl+click, etc.)
    const mouseEvent = event;
    if (mouseEvent.ctrlKey || mouseEvent.metaKey || mouseEvent.shiftKey) {
      return;
    }
    event.preventDefault();
    this.router.transitionTo(this.normalizedPath);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _class);
export { LinkToDashboardWeb as default };